import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "multiple", "accept", "onChange", "onClick"];
import { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { callIfValid } from '../utils/callIfValid';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilePickerInput = styled.input.withConfig({
  displayName: "VizExFileButton__FilePickerInput"
})(["display:none;"]);
const VizExFileButton = _ref => {
  let {
      children,
      multiple,
      accept = [],
      onChange,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const fileInputRef = useRef(null);
  const handleClick = evt => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
    callIfValid(onClick, evt);
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [children({
      onClick: handleClick
    }), /*#__PURE__*/_jsx(FilePickerInput, Object.assign({}, rest, {
      ref: fileInputRef,
      type: "file",
      accept: accept.join(','),
      multiple: multiple,
      onChange: onChange
    }))]
  });
};
VizExFileButton.displayName = 'VizExFileButton';
VizExFileButton.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};
export default VizExFileButton;